import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { CustomersCreateDataPage } from '../../../customers/customers-create/customers-create-data/customers-create-data';
import { TpvLoaderPage } from '../../../tpv/tpv-loader/tpv-loader';
import { TakeawayServices } from '../../services';
import { TakeawayCreateSelectCustomerPage } from '../../takeaway-create/takeaway-create-select-customer/takeaway-create-select-customer';

/**
 * Generated class for the TakeawayOrderInfoCustomerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-info-customer',
  templateUrl: 'takeaway-order-info-customer.html',
})
export class TakeawayOrderInfoCustomerPage {

  delivery: any;
  datetime_pickup_delivey: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    private toastCtrl: ToastController,
    public translate: TranslateService,
    public modalCtrl: ModalController) {


    this.getDeliveryImage();
    this.getDatetimePickupDelivey();
  }

  async getDeliveryImage() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //Buscamos el delivery en el listado
    if (this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.delivery != undefined) {
      this.delivery = this.takeawayServices.deliveries.find(t => t.name == this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.delivery);
    }
    //Si no encuentra ningun delivery
    if (this.delivery == undefined) {
      this.delivery = '';
    }
  }

  back() {
    if (this.takeawayServices.quick_create) {
      this.takeawayServices.quick_create = false;
      this.globals.side_menu_active = 'tpv';
      this.navCtrl.setRoot(TpvLoaderPage);
      this.globals.tourLaunchStep(1);
    } else {
      this.navCtrl.pop();
    }
  }

  showInfoCustomer() {
    if (this.takeawayServices.customer.UID) {
      this.navCtrl.push(CustomersCreateDataPage, {
        update_state: true,
        customer_uid: this.takeawayServices.customer.UID,
        name: this.takeawayServices.customer.name,
        business_name: this.takeawayServices.customer.business_name,
        business_number: this.takeawayServices.customer.business_number,
        email: this.takeawayServices.customer.email,
        phone: this.takeawayServices.customer.phone,
        address: this.takeawayServices.customer.address,
        note: this.takeawayServices.customer.note,
        alegra_contact_id: this.takeawayServices.customer.alegra_contact_id,
      })
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-no-hay-cliente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }
  async getDatetimePickupDelivey() {
    await this.takeawayServices.getIndexByTableuid();
    if (this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].datetime_pickup_delivey) {
      var _date = this.globals.timestampToDate(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].datetime_pickup_delivey);
      this.datetime_pickup_delivey = _date;
    }
  }
  editInfo() {
    this.navCtrl.push(TakeawayCreateSelectCustomerPage, {
      update_state: true,
      uid_table: this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID,
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order-info-customer/takeaway-order-info-customer.ts